import Dexie from 'dexie'
import type { EntityTable } from 'dexie'
import type {
  CompanyType,
  CredentialsType,
  CustomThemeType,
  StepsType,
  ThemeType,
  UserType,
} from '../utils/types'

export const db = new Dexie('DraftSetup') as Dexie & {
  steps: EntityTable<StepsType, 'id'>
  user: EntityTable<UserType, 'cpf'>
  company: EntityTable<CompanyType, 'cnpj'>
  credentials: EntityTable<CredentialsType>
  theme: EntityTable<ThemeType, 'theme'>
  customTheme: EntityTable<CustomThemeType, keyof CustomThemeType>
}

db.version(1).stores({
  steps: '++id, title, active, completed, id, parent',
  user: '++id, cpf, fullname, email, password, confirmPassword, acceptTerm',
  company: '++id, name, cnpj, phone, email, system',
  credentials: '++id',
  theme: '++id, theme',
  customTheme: '++id',
})
